<template>
  <main>
    <Landing />

    <More />

    <Speakabout />

    <Enjeux v-show="explain" />

    <Solutions v-show="explain" />
  </main>
</template>

<script>
import Landing from './home/Landing.vue';
import More from './home/More.vue';
import Speakabout from './home/Speakabout.vue';
import Enjeux from './home/Enjeux.vue';
import Solutions from './home/Solutions.vue';

export default {
  name: 'Home',

  components: {
    Landing,
    More,
    Speakabout,
    Enjeux,
    Solutions,
  },

  data() {
    return {
      explain: false,
    };
  },

  mounted() {
    if (/(enjeux|solutions)/.test(this.$t('hash'))) {
      this.explain = true;
      setTimeout(() => {
        document.getElementById(this.$t('hash')).scrollIntoView({ behavior: 'smooth' });
      }, 400);
    }
  },
};
</script>

<style lang="scss">
#enjeux {
  background: var(--f-r8);
}

#solutions {
  background:var(--f-v6);
}

#enjeux,
#solutions {
  .container {
    margin-top: 30px;
    margin-bottom: 30px;
    padding: 30px;
  }

  img {
    max-width: 300px;
    margin: auto;
  }
}
</style>
